import { apiFetch } from './http';

export async function loginApi(username, password) {
  return apiFetch('/auth/login', { method: 'POST', body: { username, password } });
}

export async function meApi() {
  return apiFetch('/auth/me');
}

export async function changePasswordApi({ username, email, password, newPassword }) {
  return apiFetch('/auth/change-password', {
    method: 'POST',
    body: { username, email, password, newPassword }
  });
}

export async function verifyTwoFactorApi({ pendingToken, twoFactorCode }) {
  return apiFetch('/auth/verify-2fa', {
    method: 'POST',
    body: { pendingToken, twoFactorCode }
  });
}

export async function resendTwoFactorApi({ pendingToken }) {
  return apiFetch('/auth/resend-2fa', {
    method: 'POST',
    body: { pendingToken }
  });
}
